/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Address } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';

export type addressType = 'store' | 'ship';

export interface IShippingAddressProps {
    moduleName: string;
    address: Address;
    deliveryType: string;
    showCompleteAddress?: boolean;
    resource: {
        shipToLabel: string;
        storeLabel: string;
        phoneLabel: string;
        phoneAriaLabel: string;
    };
}

const Address: React.SFC<IShippingAddressProps> = ({
    moduleName,
    address,
    deliveryType,
    showCompleteAddress,
    resource: { shipToLabel, storeLabel, phoneLabel }
}) => (
    <div className={`${moduleName}__address deliveryType-${deliveryType}`}>
        <div className={`${moduleName}__address-header`}>
            {deliveryType !== 'ship' ? storeLabel : shipToLabel}
        </div>
        {address.Name && <span className={`${moduleName}__address-name`}>
            {address.Name}
        </span>}
        {showCompleteAddress ? (<>
            {address.Street && <span className={`${moduleName}__address-street`}>
                {address.Street}
                {' '}
            </span>}
            {address.City && <span className={`${moduleName}__address-city`}>
                {address.City}
            </span>}
            {address.State && <span className={`${moduleName}__address-state`}>
                {`, ${address.State}`}
            </span>}
            {address.County && <span className={`${moduleName}__address-county`}>
                {`, ${address.County}`}
            </span>}
            {address.ZipCode && <span className={`${moduleName}__address-zipcode`}>
                {` ${address.ZipCode}`}
            </span>}
            {address.ThreeLetterISORegionName && <span className={`${moduleName}__address-threeletterisoregionname`}>
                {` ${address.ThreeLetterISORegionName}`}
            </span>}
            {address.Phone && (
                <span className={`${moduleName}__address-phone`}>
                    <span className={`${moduleName}__address-phone-label`}>
                        {phoneLabel}
                    </span>
                    <span className={`${moduleName}__address-phone-icon`} aria-hidden='true' />
                    {address.Phone}
                </span>
            )}
        </>) : address.FullAddress && <span className={`${moduleName}__address-full-address`}>
            {address.FullAddress}
        </span>}
    </div>
);

export default React.memo(Address);
